import React, { FC } from "react"
import Avatar, { AVATAR_SIZES } from "@components/Avatar/Avatar"

import { ImageType } from "@srcTypes"

import {
  PostHeroWebinarHostsDIV,
} from "./PostHeroWebinarHosts.styles"

type PostHeroWebinarHostsProps = {
  hosts: {
    image?: ImageType | null,
    jobTitle?: string | null,
    name?: string | null,
  }[]
}

const PostHeroWebinarHosts: FC<PostHeroWebinarHostsProps> = ({ hosts }) => (hosts && hosts.length > 0) ? (
  <PostHeroWebinarHostsDIV>
    <h5 className="type--text-M color--text-default margin-bottom--XS">Hosted by:</h5>
    {hosts && hosts.map(host => (
      <div key={host.name}>
        {host.image && (
          <Avatar
            name={host.name || "Webinar Host"}
            image={host.image}
            size={AVATAR_SIZES.XL}
          />
        )}
        {host.name && <h6 className="type--headline-medium-S">{host.name}</h6>}
        {host.jobTitle && <p className="font-family--mono font-size--XS color--text-light">{host.jobTitle}</p>}
      </div>
    ))}
  </PostHeroWebinarHostsDIV>
) : null

export default PostHeroWebinarHosts
